// extracted by mini-css-extract-plugin
export default {"nameLink":"_7CpBo0zs","empty":"F4_W6ATS"};